var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.noticeList.length
    ? _c(
        "div",
        { staticClass: "buyer-show" },
        [
          _c(
            "van-notice-bar",
            { attrs: { scrollable: false, wrapable: "" } },
            [
              _c(
                "van-swipe",
                {
                  staticClass: "notice-swipe",
                  attrs: {
                    vertical: "",
                    autoplay: 3000,
                    "show-indicators": false
                  }
                },
                _vm._l(_vm.noticeList, function(item) {
                  return _c("van-swipe-item", { key: item.context }, [
                    _vm._v(_vm._s(item.context))
                  ])
                }),
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }